module.exports = __webpack_public_path__ + "img/kongjian.a3ac4b06.png";